// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table {\n  border-collapse: separate;\n  border-spacing: 0px 15px;\n}\ntd {\n  width: 150px;\n  text-align: center;\n  padding: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
